let getFontFamily = () => 'Figtree'

const typography = {
	fontFamily		: getFontFamily(),
	htmlFontSize		: 14,
	fontSize			: 14,
	fontWeightLight	: 300,
	fontWeightRegular	: 400,
	fontWeightMedium	: 500,
	fontWeightBold		: 700,
	h1				: { fontFamily : getFontFamily() },
	h2				: { fontFamily : getFontFamily() },
	h3				: { fontFamily : getFontFamily() },
	h4				: { fontFamily : getFontFamily() },
	h5				: { fontFamily : getFontFamily() },
	h6				: { fontFamily : getFontFamily() },
	body1			: { fontFamily : getFontFamily() },
	body2			: { fontFamily : getFontFamily() },
	subtitle1			: { fontFamily : getFontFamily() },
	subtitle2			: { fontFamily : getFontFamily() },
	button			: { fontFamily : getFontFamily() },
	overline			: { fontFamily : getFontFamily() },
	caption			: { fontFamily : getFontFamily() },
}

export default typography